import type { AgencyPortalFeaturesDto } from './configuration';

type HasAgencyPortalFeatures = {
  agencyPortalConfiguration: {
    agencyPortalFeatures: AgencyPortalFeaturesDto;
  };
};

export function allowsEmergencyCallNotification(configuration: HasAgencyPortalFeatures | null): boolean {
  return configuration?.agencyPortalConfiguration.agencyPortalFeatures.allowEmergencyCallNotification ?? false;
}

export function isAgencyFeatureVisible(featureParameter: boolean | undefined, featureValue: boolean): boolean {
  return featureParameter != null ? featureParameter === featureValue : true;
}
